import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  ApiVersion,
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  PaginationSettings,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

/**
 * Ruckus VSZ API settings available from API
 */
export type PublicRuckusVszApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['ruckusvsz']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings &
  PaginationSettings &
  Required<ApiVersion>;

/**
 * Ruckus VSZ API settings available in backend
 */
export type RuckusVszApiSettings = PublicRuckusVszApiSettings &
  UsernamePasswordAuthentication;

/**
 * Ruckus VSZ API settings expected on API when updating
 */
export type UpdateRuckusVszApiSettings = BaseUpdateVendorApiSettings<
  PublicRuckusVszApiSettings,
  UsernamePasswordAuthentication
>;
